import FullScreenLoading from '~/components/Loading/FullScreenLoading';

const LoadingPage = () => {
  return <FullScreenLoading />;
};

export default LoadingPage;
